import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-layout">
        <div className="header-content">
          <h2 className="header-headline">Building Scalable Web &amp; AI Systems</h2>
          <p className="header-subtitle">
            I design and develop high-performance applications for ed-tech and enterprise
            platforms, combining modern web technologies with intelligent automation.
          </p>
          <ul className="header-points">
            <li>22+ years of engineering experience</li>
            <li>AI-driven and scalable architectures</li>
            <li>WCAG 2.2 AA compliant systems</li>
            <li>Interactive learning platforms</li>
          </ul>
          <a href="#projects" className="header-cta">View Projects</a>
        </div>

        <div className="pallet" aria-hidden="true">
          <div className="collage_holder"></div>
        </div>
      </div>
    </header>
  );
}

export default Header;